import { render } from "./TwoDHistogramChart.vue?vue&type=template&id=1fd08d54"
import script from "./TwoDHistogramChart.vue?vue&type=script&lang=js"
export * from "./TwoDHistogramChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__